module.exports = __webpack_public_path__ + "77098070.ico";